import {Box, Button, styled, IconButton} from '@mui/material'
import {Fragment} from 'react'
import FormikTextBox from 'shared/FormikTextbox'
import LabelAdder from './LabelAdder'
import './index.scss'
import DeleteIcon from '@mui/icons-material/Delete'

const VisuallyHiddenInput = styled('input')({
    clip: 'rect(0 0 0 0)',
    clipPath: 'inset(50%)',
    height: 1,
    overflow: 'hidden',
    position: 'absolute',
    bottom: 0,
    left: 0,
    whiteSpace: 'nowrap',
    width: 1
})

interface IssueDetailGroupProps {
    formik?: any
    isAuthenticated?: boolean
}

const IssueDetailGroup = ({formik, isAuthenticated}: IssueDetailGroupProps) => {
    const fileUploadHandler = (event) => {
        const file = event.target.files[0]
        if (!file) return

        const filename = file.name
        const dotIndex = filename.lastIndexOf('.')
        const supportedExtensions = ['.doc', '.pdf', '.jpg', '.png', '.gif']
        const reader = new FileReader()
        let containsForbiddenContent = false
        reader.onload = function () {
            const result = reader.result
            if (typeof result !== 'string') return
            const forbiddenPatterns = [
                '<script',
                'function(',
                'eval(',
                'import ',
                'from ',
                'def ',
                'os.system',
                '#!/bin/bash',
                'echo ',
                'rm -rf',
                '<?php',
                'shell_exec(',
                'exec(',
                '<!doctype html'
            ]

            // Check if file content contains restricted patterns

            containsForbiddenContent = forbiddenPatterns.some((pattern) => result.includes(pattern))
            if (
                dotIndex !== -1 &&
                supportedExtensions.includes(filename.substring(dotIndex).toLowerCase()) &&
                file.size < 1024 * 1024 &&
                !containsForbiddenContent
            ) {
                formik.setFieldValue('attachments', file)
            }
        }

        reader.readAsText(file)
    }

    return (
        <Fragment>
            <LabelAdder
                id='description'
                label='Please describe your issue.'
                showAsterik={true}
                input={<FormikTextBox formik={formik} id='description' fullWidth />}
            />
            <LabelAdder
                id='attachments'
                label='Upload document (optional)'
                input={
                    <Box className='file-upload-container'>
                        <Button component='label' variant='outlined' className='file-upload-btn'>
                            Browse
                            <VisuallyHiddenInput
                                type='file'
                                onChange={fileUploadHandler}
                                accept='.doc, .pdf, .jpg, .png, .gif'
                            />
                        </Button>
                        {formik.values.attachments?.name && (
                            <Box className='row-container'>
                                <span>{formik.values.attachments?.name}</span>{' '}
                                <IconButton
                                    className='custom-icon-button'
                                    size='small'
                                    color='error'
                                    disableRipple
                                    onClick={() => {
                                        const confirmed = window.confirm(
                                            'Are you sure you want to delete this attachment?'
                                        )
                                        if (confirmed) {
                                            formik.setFieldValue('attachments', null)
                                        }
                                    }}
                                >
                                    <DeleteIcon fontSize='small' />
                                </IconButton>
                            </Box>
                        )}{' '}
                    </Box>
                }
                helperText='Acceptable formats include .doc, .pdf, .jpg, .png, and .gif  (1MB maximum)'
            />
        </Fragment>
    )
}

export default IssueDetailGroup
